import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { admin } = useAuth();

  if (admin === null) {
    return (
      <div className="min-h-screen bg-[#0F2520] flex items-center justify-center text-[#F9F8F6]">
        Loading...
      </div>
    );
  }

  if (admin === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};
